import $ from "jquery";

// Sticky header
document.addEventListener("DOMContentLoaded", function(){
	window.addEventListener('scroll', function() {

		if (document.getElementById("body")) {

			const body = document.getElementById("body");

			if (window.scrollY > 50) {
		  	body.classList.add('fixed');		  
			} else {
		 	 body.classList.remove('fixed');
			}
		}
		
	});
}); 
// Sticky header END

